<template>
  <div class="region-issue-overlay">
    <slot />
  </div>
</template>

<style scoped lang="scss">
@import '@/stylesheets/global';
.region-issue-overlay {
  background-color: map-get($background-color, dark);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1003;
  overflow-x: auto;

  @include breakpoint(medium) {
    overflow: initial;
  }
}
</style>
